import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NavbarOwner = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language?.startsWith('ar');
  const isLoginPage = location.pathname === '/owner-login';

  const handleLogout = () => {
    localStorage.removeItem('owner_token');
    navigate('/owner-login');
  };

  const toggleLanguage = () => {
    i18n.changeLanguage(isRTL ? 'en' : 'ar');
  };

  return (
    <nav className="bg-blue-900 text-white px-6 py-3 flex items-center justify-between shadow" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="flex items-center gap-3 md:gap-6 flex-wrap">
        {isLoginPage ? (
          <div className="font-bold text-lg">{t('ownerLogin.title')}</div>
        ) : (
          <>
            <button
              className={`font-bold text-lg hover:underline ${location.pathname === '/owner-dashboard' ? 'underline' : ''}`}
              onClick={() => navigate('/owner-dashboard')}
            >
              {t('ownerDashboard.title')}
            </button>
            <button
              className={`font-bold text-lg hover:underline ${location.pathname === '/owner-settings' ? 'underline' : ''}`}
              onClick={() => navigate('/owner-settings')}
            >
              {t('ownerDashboard.tabs.settings')}
            </button>
          </>
        )}
      </div>
      <div className="flex items-center gap-3">
        <button
          className="bg-white/10 hover:bg-white/20 px-4 py-2 rounded font-bold"
          onClick={toggleLanguage}
        >
          {isRTL ? 'English' : 'العربية'}
        </button>
        {!isLoginPage && (
          <button
            className="bg-red-600 hover:bg-red-700 px-4 py-2 rounded font-bold"
            onClick={handleLogout}
          >
            {t('navbar.logout')}
          </button>
        )}
      </div>
    </nav>
  );
};

export default NavbarOwner;
